import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import ThemeSettings from '../commun/ThemeSettings';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';


export const EditBooking = () => {


  return (
    <>
      <style> {`
        th {
          background-color:#a2a7b7 !important;
          color: #fff !important;
        }
      `}
      </style>

      {/* {loading && (
        <FullScreenLoader />
      )} */}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card mb-0 ">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Property Edit Booking Details</h4>
                    </div>
                    <div className="card-body">
                      <form >
                        <div className="row">
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">Arrival:</label>
                              <input type="date" className="form-control"  />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Departure:
                              </label>
                              <input type="date" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Rate Code:
                              </label>
                              <select className="form-control form-select">
                                <option value="">select type</option>
                                <option value="Property">Property</option>
                                <option value="TravelAgent">Travel Agent</option>
                                <option value="Corporate">Corporate</option>
                              </select>
                            </div>
                          </div>



                          {/*hotel rooom table */}

                          <div className="col-md-12">
                            <div className="table-responsive">
                              <div className='text-end'>
                                <button type="button" className="btn btn-sm btn-primary mb-2 " data-bs-toggle="modal" data-bs-target="#con-close-modal"> <i className='fas fa-plus'></i> ADD </button>
                              </div>
                              <table
                                className="display table table-striped table-bordered table-hover"

                              >
                                <thead>
                                  <tr >
                                    <th className='th'> Room Type </th>
                                    <th> Plan </th>
                                    {/* <th>  Rooms </th> */}
                                    <th> Adult</th>
                                    <th>Child</th>
                                    <th> Extra Bed's</th>
                                    <th> Amount </th>
                                    <th> Action </th>
                                  </tr>
                                </thead>

                                <tbody>

                               
                                </tbody>
                              </table>
                            </div>
                          </div>


                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className="fw-bold position-absolute"
                                style={{
                                  top: "-12px",
                                  paddingInline: "8px",
                                  backgroundColor: "#f5f7fd ",
                                  left: "5px",
                                }}
                              >
                                Total Amount{" "}
                              </h6>
                              <div className="row align-items-end p-3">
                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Amount
                                    </label>
                                    <input type="number" className="form-control"  />
                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">+</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Tax (%)
                                    </label>
                                    <input type="number" className="form-control" />
                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">=</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Total Amount After Tax
                                    </label>
                                    <input type="text" className="form-control" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* guest details table */}

                          <div className="col-md-12">
                            <h4 className="mt-3">Guest Details:</h4>
                            <div className="table-responsive">
                              <table
                                className="display table table-striped table-bordered table-hover"
                                style={{
                                  width: "100%",
                                  tableLayout: "auto",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Title</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Contact No </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <select className='form-select form-control'>
                                        <option>Select</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                        <option>Dr.</option>
                                      </select>
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter First Name"/>
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter Last Name"/>
                                    </td>
                                    <td>
                                      <input type="number" className="form-control" placeholder="Enter Contact No"  />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </div>
                          </div>




                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Email:</label>
                              <input type="email" className="form-control" placeholder="Enter Email"/>
                              <div className="form-check d-flex">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault"  >
                                  Do want to receive Booking Voucher on email ?
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="col-form-label">Address</label>
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                               
                              />
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="input-block">
                              <label className="col-form-label">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter City"
                              
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">Country</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Country"
                              
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">State</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter State"
                              
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">
                                Company Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Company Name"
                              
                              />
                            </div>
                          </div>

                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className=" fw-bold position-absolute bg-gray1"
                                style={{
                                  top: "-12px",
                                  left: "12px",
                                  paddingInline: "4px",
                                }}
                              >
                                Enter GST Details (Optional)
                              </h6>
                              <div className="row p-3">
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registration Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registration Number"
                                    
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registred Company Name"
                                     
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company address
                                    </label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Registered Company Address"
                                    
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Billing Instructions:
                              </label>
                              <select className="form-select form-control" >
                                <option>Select Billing Instruction</option>
                                <option value="Pay at hotel">Pay at hotel</option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">Send Invoice</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label
                                className="col-form-label"
                                htmlFor="exampleInputEmail1"
                              >
                                Market Segment
                              </label>
                              <select
                                className="form-select form-control"
                               
                              >
                                <option>Select</option>
                                <option value="ADH">Adhoc</option>
                                <option value="AIR">Airline/ Crew</option>
                                <option value="BAR">Rate htmlFor the day </option>
                                <option value="CMP">Complimentary</option>
                                <option value="CNC">Corporate Non Contracted </option>
                                <option value="CNF">Conference</option>
                                <option value="COR"> Corporate Negotiated Rate </option>
                                <option value="CRT">Consortia</option>
                                <option value="DAY">Day Use</option>
                                <option value="GOV">Government</option>
                                <option value="HSU">House Use</option>
                                <option value="LNG">Long Stay</option>
                                <option value="LYT">Loyalty</option>
                                <option value="OTA">Online Travel Agent</option>
                                <option value="OWN">Owners</option>
                                <option value="PHR">Pharma Group</option>
                                <option value="PKG">Package</option>
                                <option value="PSU">Public Sector Unit</option>
                                <option value="PUB">Rack/ Publish tariff</option>
                                <option value="RED">Redemption</option>
                                <option value="RFP">Corporate RFP</option>
                                <option value="TRA">Travel Agent</option>
                                <option value="WDD">Wedding</option>
                                <option value="WEB">Brand Web Site</option>
                                <option value="A">Contract</option>
                                <option value="B">TR - Promotions Global</option>
                                <option value="CMP">Complimentary Rooms</option>
                                <option value="D">TR - Member Discounts</option>
                                <option value="E">TR - Negotiated Global</option>
                                <option value="G">TR - Government</option>
                                <option value="GAS">GR - ASSOCIATION</option>
                                <option value="GCP">GR - CORPORATE</option>
                                <option value="GCW">GR - CITYWIDE</option>
                                <option value="GGV">GR - GOVERNMENT</option>
                                <option value="GIC">GR - SMERF</option>
                                <option value="GSF">GR - SMERF</option>
                                <option value="GTT">GR - TOUR & TRAVEL</option>
                                <option value="H">TR - Promotions Local</option>
                                <option value="HSE">House Use</option>
                                <option value="L">TR - Negotiated Local</option>
                                <option value="M">TR - Loyalty</option>
                                <option value="O">TR - OTA Opaque</option>
                                <option value="P">TR - OTA Promotions</option>
                                <option value="Q">TR - OTA Retail</option>
                                <option value="R">TR - Retail</option>
                                <option value="T">TR - TMC</option>
                                <option value="X">TR - Wholesale Discounts</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Bus Source:
                              </label>
                              <select className="form-select form-control" >
                                <option>Select</option>
                                <option value="Online">Online</option>
                                <option value="Offline">Offline</option>
                                <option value="Corporate">Corporate</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Booking Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Special Requriment"
                               
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Payment Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Payment Comment"
                               
                              ></textarea>
                            </div>
                          </div>

                          {/* <!-- Submit Button --> */}
                          <div className="card-action text-end">
                            <button type="submit" className="btn btn-black">
                              Update
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <>
              <div
                id="con-close-modal"
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                aria-hidden="true"
                style={{ display: "none" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Add Room</h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body p-4">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              ROOM TYPE
                            </label>
                            <select className="form-control form-select" >
                              <option>select type</option>
                              
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">
                              MEAL PLAN
                            </label>
                            <select className="form-control form-select" >
                              <option>select Plan</option>
                             
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              ADULT
                            </label>
                            <select className="form-control form-select">
                              <option>0</option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                              <option>6</option>
                              <option>7</option>
                              <option>8</option>
                              <option>9</option>
                              <option>10</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              CHILD
                            </label>
                            <select className="form-control form-select" >
                              <option>0</option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                              <option>6</option>
                              <option>7</option>
                              <option>8</option>
                              <option>9</option>
                              <option>10</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label">
                              EXTRA BED
                            </label>
                            <select className="form-control form-select" >
                              <option>0</option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>4</option>
                              <option>5</option>
                              <option>6</option>
                              <option>7</option>
                              <option>8</option>
                              <option>9</option>
                              <option>10</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-info waves-effect waves-light">
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.modal */}
            </>
          </div>
          <ThemeSettings />
        </div>
      </div>
    </>
  )
}
